/* @flow */

import React from 'react';
import { Menu, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

type Props = {
  page: CatalogPage,
  hasUpdate: boolean,
  isUpdating: boolean,
  onConfirm: () => void,
};

const styles = {
  menu: {
    height: '66px',
  },
};

const SecureHeader = ({ page, hasUpdate, isUpdating, onConfirm }: Props) => (
  <Menu style={styles.menu}>
    <Menu.Item>
      <Link to={`/pages/${page.id}`} className="ui labeled icon button">
        <i className="chevron circle left icon" />
        Retour à la page
      </Link>
    </Menu.Item>
    <Menu.Item header className="borderless">{page.name}</Menu.Item>
    <Menu.Menu position="right">
      <Menu.Item>
        <Button
          onClick={onConfirm}
          loading={isUpdating}
          disabled={!hasUpdate}
          primary
          icon="save"
          content="Enregistrer"
          labelPosition="right"
        />
      </Menu.Item>
    </Menu.Menu>
  </Menu>
);

export default SecureHeader;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Secure/components/SecureHeader.js